// extracted by mini-css-extract-plugin
export default {"auth":"Reset_auth__DLXoE","topLink":"Reset_topLink__GaOfc","wrapper":"Reset_wrapper__G0eUC","header":"Reset_header__-VjqY","logo":"Reset_logo__JdX0n","title":"Reset_title__SSHpD"};